export default __webpack_public_path__ + "static/media/svg-5.06f72281.svg";